/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
export const TWO_FACTOR_POST_LOGIN_PROMO_FLOWS = Object.freeze({
  SMS: 'SMS',
  CODE: 'CODE',
  FINISH: 'FINISH'
});
let TwoFactorPostLoginPromoBaseComponent = (_dec = service('ember-multipassfe-client'), _dec2 = service('ember-multipass-logging'), _class = class TwoFactorPostLoginPromoBaseComponent extends Component {
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor2, this);
    _initializerDefineProperty(this, "logger", _descriptor3, this);
    _defineProperty(this, "flows", TWO_FACTOR_POST_LOGIN_PROMO_FLOWS);
    _initializerDefineProperty(this, "flow", _descriptor4, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor5, this);
    _initializerDefineProperty(this, "phoneNumberDisplay", _descriptor6, this);
    _initializerDefineProperty(this, "smsBlockedManualOptInModalOpen", _descriptor7, this);
    this.logger.addComponentBreadcrumb('TwoFactorPostLoginPromoBaseComponent');
  }
  setFlow(newFlow) {
    this.flow = newFlow;
  }
  setPhoneNumber(newPhoneNumber) {
    this.phoneNumber = newPhoneNumber;
  }
  setPhoneNumberDisplay(newPhoneNumberDisplay) {
    this.phoneNumberDisplay = newPhoneNumberDisplay;
  }
  async resendSmsTwoFactorCodeDebounced() {
    debounce(this, this.resendSmsTwoFactorCode, 500, true);
  }
  async resendSmsTwoFactorCode() {
    try {
      await this.multipassfeClient.enrollTwoFactorSms(this.phoneNumber);
    } catch (e) {
      switch (e.message) {
        case 'TEMPORARY_LOCKOUT':
          break;
        case 'BLOCKED_SMS_NUMBER':
          this.smsBlockedManualOptInModalOpen = true;
          break;
        default:
          this.logger.sentryError(e);
          this.error = this.intl.t(this.args.tPrefix + 'generic_errors.other.unknown');
      }
    }
  }
  handleSmsBlockedManualOptInModalClose() {
    this.smsBlockedManualOptInModalOpen = false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "flow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.flows.SMS;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberDisplay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "smsBlockedManualOptInModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumberDisplay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumberDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendSmsTwoFactorCodeDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendSmsTwoFactorCodeDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendSmsTwoFactorCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendSmsTwoFactorCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSmsBlockedManualOptInModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSmsBlockedManualOptInModalClose"), _class.prototype), _class);
export { TwoFactorPostLoginPromoBaseComponent as default };